import accounting from 'accounting'

export default function currency (value, digits) {
  if (digits === null || digits === undefined) {
    digits = 0
  }

  return accounting.formatMoney(value, {
    symbol: '€',
    precision: digits,
    decimal: ',',
    thousand: ' ',
    format: {
      pos: '%v %s',
      neg: '- %v %s',
      zero: '- €'
    }
  })
}
